import { useEffect, useState } from "react";
import SvgCircleFitText from "../../preview/SvgCircleFitText";
import SvgPolygonWrappableText from "../../preview/SvgPolygonWrappableText";
import pxFromCm from "../../util/pxFromCm";
import { BrochureHeader } from "./BrochureHeader";
import { BrochurePage1Text } from "./BrochurePage1Text";
import { useIsHardNo } from "../../util/useDomain";

interface BrochurePreviewFrontProps {
  bigHeader: string;
  subheader: string;
  page1Text: string;
  page2TextTop: string;
  page2TextBottom: string;
  page2TextTopCircle: string;
  page2TextBottomCircle: string;
  page3TextTop: string;
  page3TextBottom: string;
  page3TextCircle: string;
}

export const BrochurePreviewFront: React.FC<BrochurePreviewFrontProps> = ({
  bigHeader, subheader, page1Text, page2TextTop, page2TextBottom,
  page2TextTopCircle, page2TextBottomCircle,
  page3TextTop, page3TextBottom, page3TextCircle
}) => {
  const { isHardNo } = useIsHardNo();
  const [fontSize, setFontSize] = useState(39);
  const [recursion, setRecursion] = useState(0);
  const [overflowing, setOverflowing] = useState(false);
  const width = 702 * 5;

  const px2 = 29.7 / 3;
  const px1 = 29.7 * 2 / 3;
  const backgroundImage = isHardNo
    ? "url('/hardno_brochure_front_page_no_text.png')"
    : "url('/brochure_front_page_no_text.png')";


  const handlePolygonOverflow = (_h, _boxes, overflow) => {
    if (overflow) {
      console.log("overflow");
      setOverflowing(true);
    }
  };

  useEffect(() => {
    setRecursion(0);
    setFontSize(39);
  }, [page2TextTop, page2TextBottom, page3TextTop, page3TextBottom])

  useEffect(() => {
    if (overflowing && recursion < 20) {
      console.log("newFontSize:", (fontSize - 1));
      setOverflowing(false);
      setFontSize(fontSize - 1);
    }
  }, [overflowing]);

  return (<>
    {true && <div style={{
      width: "100%",
      height: "100%",
      backgroundImage: backgroundImage,
      backgroundSize: 'cover',
      backgroundPosition: 'center',
    }} />}
    <svg width="100%" height="100%" style={{position: "absolute", top: "0px", left: "0px"}} className="has-custom-font">
      <BrochureHeader
        bigHeader={bigHeader}
        subheader={subheader}
        x={width * 2 / 3 + pxFromCm(0.96)}
        y={pxFromCm(1.0)}
        width={width / 3 - 2 * pxFromCm(0.96)}
        height={pxFromCm(6.2 - 1.0 - 0.6)}
      />
      <BrochurePage1Text
        text={page1Text}
        x={width * 2 / 3 + pxFromCm(0.96)}
        y={pxFromCm(15.0)}
        width={width / 3 - 2 * pxFromCm(0.96)}
        height={pxFromCm(5.0)}
      />
      <SvgCircleFitText
        text={page2TextTopCircle}
        cx={pxFromCm(17.3)}
        cy={pxFromCm(2.5)}
        r={140}
        color="black"
        fontSize={44}
      />
      {true && <SvgPolygonWrappableText
        text={page2TextTop}
        polygon={[
          px2 + 0.96, 1.0,
          px2 + 0.96 + 4.9, 1.0,
          px2 + 0.96 + 4.4, 2.5,
          px2 + 0.96 + 4.9, 4.0,
          px2 + 0.96 + 4.8 + 1.5, 4.4,
          px1 - 0.96, 4.4,
          px1 - 0.96, 5.7,
          px2 + 6.0, 6.0,
          px2 + 4.0, 6.4,
          px2 + 0.96, 7.2,
        ].map((p) => pxFromCm(p))} 
        color="black"
        fontSize={fontSize} 
        textAnchor="left"
        onLayout={handlePolygonOverflow}
      />}
      <SvgCircleFitText
        text={page2TextBottomCircle}
        cx={pxFromCm(16.8)}
        cy={pxFromCm(18.0)}
        r={190}
        color="black"
        fontSize={44}
      />
      {true && <SvgPolygonWrappableText
        text={page2TextBottom}
        polygon={[
          px2 + 0.96 + 2.0, 9.62,
          px1 - 0.96 - 1.2, 9.62,
          px1 - 0.96, 9.62 + 0.8,
          px1 - 0.96, 15.75,
          px1 - 0.96 - 2.75, 15.75,
          px1 - 0.96 - 4.0, 16.6,
          px1 - 0.96 - 4.5, 17.75,
          px1 - 0.96 - 4.4, 18.75,
          px1 - 0.96 - 4.0, 20.0,
          px2 + 0.96, 20.0,
          px2 + 0.96, 11.62,
          px2 + 0.96 + 0.9, 11.62 - 1.1,
        ].map((p) => pxFromCm(p))} 
        color="black"
        fontSize={fontSize} 
        textAnchor="left"
        onLayout={handlePolygonOverflow}
      />}
      <SvgPolygonWrappableText
        text={page3TextTop}
        polygon={[
          0.96, 1.0,
          px2 - 0.96, 1.0,
          px2 - 0.96, 7.5,
          4.5, 9.2,
          2.5, 10.4,
          0.96, 11.8,
        ].map((p) => pxFromCm(p))} 
        color="black"
        fontSize={fontSize} 
        textAnchor="left"
        onLayout={handlePolygonOverflow}
      />
      <SvgCircleFitText
        text={page3TextCircle}
        cx={pxFromCm(4.95)}
        cy={pxFromCm(14.2)}
        r={240}
        color="white"
        fontSize={48}
      />
      <SvgPolygonWrappableText
        text={page3TextBottom}
        polygon={[
          0.96, 18.5,
          px2 - 0.96, 18.5,
          px2 - 0.96, 20.2,
          0.96, 20.2,
        ].map((p) => pxFromCm(p))} 
        color="black"
        fontSize={fontSize} 
        textAnchor="left"
        onLayout={handlePolygonOverflow}
      />
    </svg>
  </>)
}
